import { lsApiService, lsErrorService } from 'ls-vue-common';
import {
  LONG_GRASS__GET,
  LONG_GRASS__SUBMIT_DISPUTE,
  LONG_GRASS__MUTATE_LONG_GRASS,
  LONG_GRASS__MUTATE_LONG_GRASS_IMAGES,
  LONG_GRASS__MUTATE_LOADING_STATUS,
} from '@/store/types';

const createInitialState = () => {
  return {
    id: null,
    scheduleEventId: null,
    scheduleEventStatusSetAt: null,
    label: null,
    originalPrice: null,
    lgPrice: null,
    trustFee: null,
    tax: null,
    total: null,
    images: {
      before: [],
      after: [],
    },
    loadingStatus: {
      isLoading: false,
      isUpdating: false,
    },
    dispute: {},
    draft: {},
  };
};

export const mutations = {
  [LONG_GRASS__MUTATE_LOADING_STATUS](state, payload) {
    state.loadingStatus = { ...state.loadingStatus, ...payload };
  },
  [LONG_GRASS__MUTATE_LONG_GRASS](
    state,
    {
      id,
      lgPrice,
      originalPrice,
      scheduleEventId,
      tax,
      total,
      trustFee,
      label,
      scheduleEventStatusSetAt,
      isDisputable,
      disputeStatus,
      disputeUpdated,
      draft,
    }
  ) {
    state.id = id;
    state.scheduleEventId = scheduleEventId;
    state.scheduleEventStatusSetAt = scheduleEventStatusSetAt;
    state.label = label;
    state.lgPrice = lgPrice;
    state.originalPrice = originalPrice;
    state.tax = tax;
    state.total = total;
    state.trustFee = trustFee;
    state.dispute = {
      isDisputable: isDisputable,
      status: disputeStatus,
      updated: disputeUpdated,
    };
    state.draft = draft;
  },
  [LONG_GRASS__MUTATE_LONG_GRASS_IMAGES](state, payload) {
    const mapped = payload.map(({ id, image_url: src, thumbnail_url: thumbSrc, tag }) => {
      const splitTag = tag.split('.');

      return {
        id,
        src,
        thumbSrc,
        caption: splitTag[splitTag.length - 1],
        moment: splitTag[1],
      };
    });

    state.images = {
      before: mapped.filter(({ moment }) => moment === 'beforeJob'),
      after: mapped.filter(({ moment }) => moment === 'afterJob'),
    };
  },
};

export const actions = {
  [LONG_GRASS__GET]({ commit, rootState }, { propertyId, scheduleId, scheduleEventId, reportId }) {
    commit(LONG_GRASS__MUTATE_LOADING_STATUS, { isLoading: true });

    const { customer_id } = rootState.auth.user;

    return lsApiService
      .request({
        method: 'GET',
        route: `/customers/${customer_id}/properties/${propertyId}/schedules/${scheduleId}/scheduleevents/${scheduleEventId}/longgrass/${reportId}?include=draft`,
      })
      .then(({ data: report }) => {
        const { dispute } = report;
        const isDisputable =
          report.scheduleEvent.is_completion_disputable && !report.scheduleEvent.dispute_id;

        commit(LONG_GRASS__MUTATE_LONG_GRASS, {
          id: report.id,
          scheduleEventId: report.scheduleEvent.id,
          scheduleEventStatusSetAt: report.scheduleEvent.status_set_at,
          label: report.longgrass_label,
          originalPrice: report.scheduleEvent.price,
          lgPrice: report.price,
          trustFee: report.scheduleEvent.trust_fee,
          tax: report.total_tax,
          total: report.total_price,
          isDisputable,
          disputeStatus: (dispute || {}).dispute_status,
          disputeUpdated: (dispute || {}).dispute_status_set_at,
          draft: report.draft,
        });
        commit(LONG_GRASS__MUTATE_LONG_GRASS_IMAGES, report.images);
      })
      .catch((error) => {
        lsErrorService.log({ error });
      })
      .finally(() => {
        commit(LONG_GRASS__MUTATE_LOADING_STATUS, { isLoading: false });
      });
  },
  [LONG_GRASS__SUBMIT_DISPUTE](
    { commit, rootState },
    { propertyId, scheduleId, scheduleEventId, longgrassId, ...payload }
  ) {
    commit(LONG_GRASS__MUTATE_LOADING_STATUS, { isLoading: true });

    const { customer_id } = rootState.auth.user;

    return lsApiService
      .request({
        method: 'POST',
        route: `/customers/${customer_id}/properties/${propertyId}/schedules/${scheduleId}/scheduleevents/${scheduleEventId}/longgrass/${longgrassId}/dispute`,
        payload,
      })
      .then(() => {
        return true;
      })
      .catch((error) => {
        lsErrorService.log({ error, showAlert: true });
        return false;
      })
      .finally(() => {
        commit(LONG_GRASS__MUTATE_LOADING_STATUS, { isLoading: false });
      });
  },
};

export const longGrass = {
  state: createInitialState,
  mutations,
  actions,
};
